import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import { withRouter } from 'react-router-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware, ConnectedRouter } from 'connected-react-router';

import { requireUser } from './redux/middleware/permissions';
import { axiosAuth } from './redux/middleware/axios';
import reducer from './redux/reducers';
import App from './App';

import 'axios-progress-bar/dist/nprogress.css';

import * as serviceWorker from './serviceWorker';

const history = createBrowserHistory();

let store;
if (process.env.NODE_ENV === 'production') {
  store = createStore(
    reducer(history),
    applyMiddleware(routerMiddleware(history), thunk, requireUser, axiosAuth)
  );
} else {
  // eslint-disable-next-line global-require
  const logger = require('redux-logger').default;
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(
    reducer(history),
    composeEnhancers(
      applyMiddleware(routerMiddleware(history), thunk, requireUser, axiosAuth, logger)
    )
  );
}

const AppWithRouter = withRouter((props) => <App {...props} />);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      {/* <ThemeProvider theme={theme}> */}
         <AppWithRouter />
      {/* </ThemeProvider> */}
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
